<ng-content></ng-content>

<div class="uni-toggle">
  <span class="uni-toggle__tick"></span>
</div>
<span *ngIf="activeLabel || inactiveLabel">
  {{ value === activeValue ? activeLabel : inactiveLabel }}
</span>
